/**
 * DUE-221 (Task 10): which reauth strategy `client.ts`'s `reauthenticate()`
 * uses on a 401. The main app bundle never touches this (stays "app" —
 * Telegram initData / iOS device-guest, unchanged). The standalone admin
 * bundle (`web/src/admin/main.tsx`) calls `setAuthMode("admin-web")` before
 * anything else renders, switching the 401 path to `adminWebAuthenticate()`
 * (refresh-token-only, no fallback identity).
 *
 * Module-level state, not a store: this is read synchronously inside
 * `client.ts` on every request, and only one of the two bundles is ever
 * loaded in a given page load — there's no cross-bundle sharing to model.
 */
export type AuthMode = "app" | "admin-web";

let mode: AuthMode = "app";

export function setAuthMode(next: AuthMode): void {
  mode = next;
}

export function getAuthMode(): AuthMode {
  return mode;
}

/** Testing hook: restore the default mode between tests. */
export function __resetAuthModeForTests(): void {
  mode = "app";
}
